import type { UploaderFileListsProps } from "./FileList/types";
import UploaderFileList from "./FileList/index";

function UploaderFileLists({
  fileErrors,
  processingFiles,
  successFiles,
  onDelete,
  onReselect,
  listVariant,
  isEmpty
}: UploaderFileListsProps) {
  if (isEmpty) {
    return null;
  }
  return (
    <>
      <UploaderFileList
        files={fileErrors}
        onDelete={onDelete}
        onReselect={onReselect}
        listVariant={listVariant}
      />
      <UploaderFileList
        files={processingFiles}
        onDelete={onDelete}
        onReselect={onReselect}
        processing
        listVariant={listVariant}
      />
      <UploaderFileList
        files={successFiles}
        onDelete={onDelete}
        onReselect={onReselect}
        listVariant={listVariant}
      />
    </>
  );
}

export default UploaderFileLists;
